function GetDate(dates, interval) {
    if (interval > 0) {
        dates = new Date(dates.getTime() - (interval * 24 * 60 * 60 * 1000));
    }
    let month = dates.getMonth() + 1; let date = dates.getDate();
    month = (month >= 10) ? month : "0" + month;
    date = (date >= 10) ? date : "0" + date;
    let x;
    if (interval == 'fromDate') {
        x = dates.getFullYear() + "-" + month + "-01";
    }
    else {
        x = dates.getFullYear() + "-" + month + "-" + date;
    }
    return x;
}

export default GetDate;
  